const API_BASE = '/api/entrepreneur-catalog'

const request = async (url, options = {}) => {
  const response = await fetch(url, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  })

  let data = null
  try {
    data = await response.json()
  } catch {
    data = null
  }

  if (!response.ok) {
    const message = data?.message || data?.title || `HTTP ${response.status}`
    const error = new Error(message)
    error.response = { status: response.status, data }
    throw error
  }

  return data
}

export const getPublicCatalogUrl = (slug) => `/catalogo/${encodeURIComponent(slug || 'your-slug')}`

export const entrepreneurCatalogService = {
  getPublicCatalog: (slug, query = '', page = 1, pageSize = 24, options = {}) => {
    const params = new URLSearchParams()
    if (query && query.trim()) params.set('q', query.trim())
    params.set('page', String(page))
    params.set('pageSize', String(pageSize))
    return request(`${API_BASE}/public/${encodeURIComponent(slug)}?${params.toString()}`, options)
  },
  getPublicProduct: (slug, productId) => request(`${API_BASE}/public/${encodeURIComponent(slug)}/products/${productId}`),
  getProfile: () => request(`${API_BASE}/me/profile`),
  saveProfile: (payload) => request(`${API_BASE}/me/profile`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  }),
  getCategories: (params = {}) => {
    const query = new URLSearchParams()
    if (params.page != null) query.set('page', String(params.page))
    if (params.pageSize != null) query.set('pageSize', String(params.pageSize))
    const suffix = query.toString() ? `?${query.toString()}` : ''
    return request(`${API_BASE}/me/categories${suffix}`)
  },
  createCategory: (payload) => request(`${API_BASE}/me/categories`, {
    method: 'POST',
    body: JSON.stringify(payload)
  }),
  updateCategory: (categoryId, payload) => request(`${API_BASE}/me/categories/${categoryId}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  }),
  deleteCategory: (categoryId) => request(`${API_BASE}/me/categories/${categoryId}`, {
    method: 'DELETE'
  }),
  getProducts: (params = {}) => {
    const query = new URLSearchParams()
    if (typeof params === 'string') {
      if (params.trim()) query.set('q', params.trim())
    } else {
      if (params.q && params.q.trim()) query.set('q', params.q.trim())
      if (params.page != null) query.set('page', String(params.page))
      if (params.pageSize != null) query.set('pageSize', String(params.pageSize))
    }
    const suffix = query.toString() ? `?${query.toString()}` : ''
    return request(`${API_BASE}/me/products${suffix}`)
  },
  createProduct: (payload) => request(`${API_BASE}/me/products`, {
    method: 'POST',
    body: JSON.stringify(payload)
  }),
  updateProduct: (productId, payload) => request(`${API_BASE}/me/products/${productId}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  }),
  deleteProduct: (productId) => request(`${API_BASE}/me/products/${productId}`, {
    method: 'DELETE'
  }),
  createVideo: (productId, payload) => request(`${API_BASE}/me/products/${productId}/videos`, {
    method: 'POST',
    body: JSON.stringify(payload)
  }),
  deleteVideo: (productId, videoId) => request(`${API_BASE}/me/products/${productId}/videos/${videoId}`, {
    method: 'DELETE'
  })
}
